import axios from '@/config/axios.config';
import { creatUrlParams } from '@/utils/url';

let devApi = {
  getAccess: '/api/v1/auth/getAccessOut',
  commonPhases: '/api/v1/invoke/phases',
}

const previewMixin = {
  data() {
    return {
      tokenRes: ''
    }
  },
  methods: {
    getDevBase(url) {
      let {
        platformcode,
        ticket
      } = this.$route.query;
      url = window.location.origin + url
      let params = {
        "platformcode": platformcode,
        "ticket": ticket,
        "url": url
      };
      return axios.devPost(devApi.getAccess, {}, params);
    },
    async sendDevRequest(url = devApi.commonPhases, params = {}) {
      if (this.tokenRes) {
        url = creatUrlParams(url, params)
        return axios.devGet(url, {}, {
          ...this.tokenRes,
          'Authorization': this.tokenRes.Authorization
        });
      }
      url = creatUrlParams(url, params)
      let res = await this.getDevBase(url)
      if (!res || res.Authorization.indexOf('null') > -1 || res.Authorization.length < 12) {
        return Promise.reject({
          msg: 'access_token 无效'
        })
      }
      this.tokenRes = res
      return axios.devGet(url, {}, {
        ...res,
        'Authorization': res.Authorization
      });
    }
  },
}

export default previewMixin;



// WEBPACK FOOTER //
// ./src/pages/preview/mixins/previewMixin.js